import { ChangeDetectorRef, Component, DestroyRef, ElementRef, inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { ProxyServiceFetchURLService } from '../../../../../../../shared/services/proxy-service-fetch-url.service';
import { Category } from '../../../../../../admin-panel/components/pages/category/models/category';
import { CacheService } from '../../../../../../../shared/services/cache.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { IconPackDetail, PackAsset } from '../../../../../../contributor/components/profile/contributors/pack/models/pack';
import { ConversionResponse, PaginatedResult } from '../../../../../../../common/models/api-response';
import { FilterOptionsEnum } from '../../../../../../../shared/models/filter-options-enum';
import { LisenceEnum } from '../../../../../../../shared/models/license';
import { PackService } from '../../../../../../contributor/components/profile/contributors/pack/services/pack.service';
import { CategorySearchEnum } from '../../../../../../admin-panel/components/pages/category/enums/categorySearch-enum';
import { IconGalleryService } from '../../../gallery/icon-gallery/services/iconGallery.service';
import { SharedService } from '../../../../../../../shared/services/shared.service';
import { ImageFormat } from '../../../gallery/icon-gallery/models/image-format';
import { AlertService } from '../../../../../../../shared/services/alert.service';
import { MatDialogNavigation } from '../../../../../../../shared/models/mat-dialog-navigation';
import { RouteService } from '../../../../../../../shared/services/route.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageKeysEnum } from '../../../../../../../shared/models/localStorageKeys-enum';
import { BlobService } from '../../../../../../../shared/services/blob.service';
import { AppRoutesUtils } from '../../../../../../../utils/app-routes-util';
import { ConfirmationPopupComponent } from '../../../../../../../shared/components/confirmation-popup/confirmation-popup';
import { syncBlobTokens } from '../../../../../../../shared/utils/blob-token-sync';
type Tabs = string;
@Component({
  selector: 'app-svg-editor',
  standalone:false,
  templateUrl: './svg-editor.component.html',
  styleUrl: './svg-editor.component.css'
})
export class SvgEditorComponent implements OnInit {
  fileError!:string;
  isIcon=false;
  isDragOver = false;
  lisenceEnum=LisenceEnum;
  lisenceEnumTypes:LisenceEnum[]=Object.values(LisenceEnum);
  activeLicense: LisenceEnum = LisenceEnum.Free; // Default selection
  svgString!: string;
  assetSubscription!: Subscription;
  selectedAssetCategory: string = FilterOptionsEnum.None;
  selectedIconColor: string = FilterOptionsEnum.None;
  selectedPreference: string = FilterOptionsEnum.None;
  selectedStyle: string = FilterOptionsEnum.None;
  content: string = LisenceEnum.Free.toString().toLowerCase();
  category!: string;
  imageFormat = ImageFormat;
  categories: Category[] = [];
  categoriesTabs: Tabs[] = [];
  categoriesStyles: string[] = [];
  allAssets: string = 'All Assets';
  fileSelected = false;
  tilesSelected = false
  fileName: string | null = null;
  colors: string = '#FF0000'
  selectedSection: string = 'color';
  svgColors: string[] = [];
  assets: PackAsset[] = [];
  uniquesvgColors: string[] = []
  showColorPicker = false;
  selectedColor = '#000000';
  page = 1;
  itemsPerPage = 100;
  isUserLogin!: boolean;
  iconPackID!: string;
  iconPackDetailID: string | null = null;
  search: string = '';
  loading: boolean = false;
  token!: string;
  activeTab: Tabs = 'Illustrations';
  activesTab: Tabs = LisenceEnum.Free;
  isContentPreparing: boolean = false;
  assetsPaginated?: PaginatedResult<PackAsset> | null =
    new PaginatedResult<PackAsset>();
  iconPackDetail: IconPackDetail | null = null;
  isScrolled: boolean = false;
  isRefreshComponent: boolean = false;
  isPopupOpened: boolean = false;
  total!: number;
  searchLevel='Individual';

  colorPickerPosition = { top: '0px', left: '0px' };
  selectedElementIndex: number | null = null;
  backgroundShape: string = "square"
  backgroundColor: string = "aqua"
  height = "50%";
  width = "50%";
  colorPalettes: string[][] = [];
  undoStack: string[] = [];
  redoStack: string[] = [];
  tilesColor: string[] = [
    "#FF5733",
    "#1ABC9C",
    "#3498DB",
    "#9B59B6",
    "#F39C12",
    "#16A085",
    "#8E44AD"
  ];
  isIconDownloading: boolean = false;
  private confirmDialogRef?: MatDialogRef<ConfirmationPopupComponent>;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef<HTMLInputElement>;
  private readonly destroyRef = inject(DestroyRef);
  constructor(
    private cacheService: CacheService,
    public proxyServiceFetchURLService: ProxyServiceFetchURLService,
    private packService: PackService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    public iconGalleryService: IconGalleryService,
    private sharedService: SharedService,
    private alertService: AlertService,
    private routeService: RouteService,
    private router: Router,
    private dialog: MatDialog,
    private blobService: BlobService,
  ) {
    syncBlobTokens({
      blobService: this.blobService,
      destroyRef: this.destroyRef,
      setToken: (t) => (this.token = t ?? ''),
      cdr: this.cdr,
    });
  }
  async ngOnInit() {
    await this.getblobToken();
    this.isUserLogin = this.sharedService.getAuthFromLocalStorage() !== undefined;
    await this.getCategoriesFromCache();
    this.search = '';
    this.reset();
    await this.getPackAssets();
    this.addMultipleRandomPalettes(10);
     window.addEventListener('dragover', (e) => {
    e.preventDefault();
  });
  window.addEventListener('drop', (e) => {
    e.preventDefault();
  });
  }


iconDownload() {
    if(this.isIcon){
      this.downloadIcon(this.imageFormat.Svg);
    }
    else{
      this.downloadSVG();
    }

}
  async setTab(tab: Tabs) {

    if (this.activeTab === tab) return;
    this.activeTab = tab;
    this.category = this.getCategory(this.activeTab as string)?.name || '';
    this.assets=[];
    this.page = 1;
    this.loading=true;
    this.assetSubscription?.unsubscribe();
    await this.getPackAssets();

  }


  setsTab(tab: Tabs) {
    if (this.activesTab !== tab) {
      this.activesTab = tab;
      this.content=tab;
      this.assets=[];
      this.page = 1;
      this.assetSubscription?.unsubscribe();
      this.getPackAssets();
    }
  }
  activesClass(tab: Tabs) {
    return tab === this.activesTab ? 'bg-[#FFFFFF] text-[#121212]' : '';
  }


  generateRandomColor(): string {
    return '#' + Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, '0');
  }

  generateRandomPalette(count = 5): string[] {
    return Array.from({ length: count }, () => this.generateRandomColor());
  }

  addRandomPalette(): void {
    const newPalette = this.generateRandomPalette(5);
    this.colorPalettes.unshift(newPalette);
  }

  addMultipleRandomPalettes(amount: number = 50): void {
    for (let i = 0; i < amount; i++) {
      this.colorPalettes.push(this.generateRandomPalette());
    }
  }
  loadNextPaletteBatch(batchSize = 50) {
    for (let i = 0; i < batchSize; i++) {
      this.colorPalettes.push(this.generateRandomPalette());
    }
  }
  undo(): void {


    const svgContainer = document.getElementById('svgDisplay');
    if (!svgContainer || this.undoStack.length === 0) return;

    const currentSvg = svgContainer.querySelector('svg');
    if (currentSvg) {

      const serializer = new XMLSerializer();
      const currentSvgString = serializer.serializeToString(currentSvg);
      this.redoStack.push(currentSvgString);
    }

    const previousState = this.undoStack.pop();
    if (previousState) {

      svgContainer.innerHTML = previousState;
      requestAnimationFrame(() => this.extractColorsFromRenderedSVG());
    }
  }

  redo(): void {
    const svgContainer = document.getElementById('svgDisplay');
    if (!svgContainer || this.redoStack.length === 0) return;

    const currentSvg = svgContainer.querySelector('svg');
    if (currentSvg) {
      const serializer = new XMLSerializer();
      const currentSvgString = serializer.serializeToString(currentSvg);
      this.undoStack.push(currentSvgString);
    }

    const nextState = this.redoStack.pop();
    if (nextState) {
      svgContainer.innerHTML = nextState;
      requestAnimationFrame(() => this.extractColorsFromRenderedSVG());
    }
  }
  resetEditor(): void {
    this.width = "100px";
    this.height = "100px";
    this.backgroundShape = "none";
    this.backgroundColor = "aqua";
    this.tilesSelected = false;
      const svgContainer = document.getElementById('svgDisplay');
    if (!svgContainer || this.undoStack.length === 0) return;
    const previousState = this.undoStack[0];
    if (previousState) {

      svgContainer.innerHTML = previousState;
      requestAnimationFrame(() => this.extractColorsFromRenderedSVG());
    }
    // this.undo();
    // this.clear();
  }
  activeClass(tab: Tabs) {
    return tab === this.activeTab
      ? 'text-themeBlackTwo border-b-2 border-themeBlackTwo'
      : '';
  }
  async getCategoriesFromCache() {
    const response: Category[] = await firstValueFrom(this.cacheService.getCategoriesFromCache());
    this.categories = response.filter(c=> c.sourceFileType==="svg");
    this.categoriesTabs = [
      ...this.categories
        .map((category) => category.menuName)
        .filter((name): name is Tabs => name !== undefined),
    ];
    this.activeTab = this.categoriesTabs[0];
    this.category = this.getCategory(this.activeTab as string)?.name || '';
  }

  viewMore(): void {
    if (this.assetsPaginated?.hasNext) {
      this.page += 1;
      this.isScrolled = true;
      this.assetsPaginated.hasNext = false;
      this.getPackAssets();
    } else {
      this.isScrolled = false;
    }
  }
  trackByIconPackDetailID(index: number, item: any): string {
    return `${item.iconPackDetailID}_${index}`;
  }
  SetDialogWidth(): string {
    let returnWidth;
    let windowWidth = window.innerWidth;
    switch (true) {
      case windowWidth < 450: {
        returnWidth = '90%';
        break;
      }
      case windowWidth >= 450 && windowWidth < 750: {
        returnWidth = '50%';
        break;
      }
      default:
        returnWidth = '870px';
    }
    return returnWidth;
  }
  openConfirmDialog(
    title: string,
    message: string,
    confirmText: string,
    matDialogNavigation: MatDialogNavigation,
    outOfQouta:boolean = false
  ): void {
    this.confirmDialogRef = this.dialog.open(ConfirmationPopupComponent, {
      width: this.SetDialogWidth(),
      hasBackdrop: true,
      disableClose: false,
      panelClass: ['center-popup', 'overflow_visible'],
      data: {
        title: title,
        description: message,
        buttonTitle: confirmText,
      },
    });
    this.confirmDialogRef.afterClosed().subscribe((resultData) => {
      this.confirmDialogRef = undefined;
      if (resultData) {
        if (
          matDialogNavigation === MatDialogNavigation.UpgradePlan ||
          matDialogNavigation == MatDialogNavigation.IsUserIPExceedingLimit
        ) {
          this.navigateToPricing();
        }
      }
    });
  }

  async getblobToken() {
    this.token = await firstValueFrom(this.blobService.getBlobToken());
  }

  navigateToPricing(): void {
    const url: string = !this.isUserLogin ? '/pricing' : '/profile/pricing';
    const redirectRoute = this.router.url;
    const outOfQouta = false; // Assuming this is false, adjust as needed
    AppRoutesUtils.Pricing.navigateToPricing(url,outOfQouta,redirectRoute);
  }

  upgradePlan(title: string): void {
    const  outOfQouta=false; // Assuming this is false, adjust as needed
    this.openConfirmDialog(
      title,
      'Please upgrade your plan',
      'Upgrade Plan',
      MatDialogNavigation.UpgradePlan,
      outOfQouta
    );
  }

  userOrIPExceedingDownloads(): void {
    this.openConfirmDialog(
      'Unlock Premium Collections',
      "It looks like you're enjoying our icons! To continue accessing exclusive designs, we invite you to explore our premium packages",
      'View Plans',
      MatDialogNavigation.IsUserIPExceedingLimit
    );
  }
   async downloadIcon(format: string) {
    if (
      !this.isUserLogin &&
      this.iconPackDetail?.lisenceName === LisenceEnum.Premium
    ) {
      this.navigateToPricing();
    } else {
      this.isIconDownloading = true;
      this.iconGalleryService
        .downloadIcon(this.iconPackDetail!, format, 512, this.isUserLogin)
        .subscribe({
          next: async (response: ConversionResponse) => {
            const fullUrl = await this.blobService.buildDownloadBlobUrl(response.url);
            if (this.isUserLogin) {
              if (this.iconPackDetail?.lisenceName === LisenceEnum.Premium) {
                if (
                  response.hasIntroSubscription &&
                  response.alreadyDownloaded
                ) {
                  this.downloadSVG()
                  this.isIconDownloading = false;
                  return;
                } else if (
                  response.outOfQouta ||
                  response.hasIntroSubscription
                ) {
                 this.isIconDownloading = false;
                  const title: string = response.outOfQouta
                    ? 'Out of Quota'
                    : 'Intro Subscription';
                  this.upgradePlan(title);
                  return;
                } else if (!response.isSubscriptionActive) {
                  this.isIconDownloading = false;
                  this.navigateToPricing();
                  return;
                }
              } else if (this.iconPackDetail?.lisenceName === LisenceEnum.Free) {
                if (
                  response.hasIntroSubscription &&
                  response.isUserOrIPExceedingDownloads
                ) {
                  this.downloadSVG()
                  this.isIconDownloading = false;
                  this.userOrIPExceedingDownloads();
                  return;
                }
              }
            } else {
              if (response.isUserOrIPExceedingDownloads) {
               this.downloadSVG()
               this.isIconDownloading = false;
                this.userOrIPExceedingDownloads();
                return;
              }
            }
           this.downloadSVG()
           this.isIconDownloading = false;
            this.cdr.detectChanges();
          },
          error: (error) => {
            console.error('Error during the API call:', error);
            console.warn(
              'error->',
              error?.error?.errors?.[0]?.message || error?.error
            );
            this.alertService.errorNotification(
              error?.error?.errors?.[0]?.message
            );
            this.isIconDownloading = false;
          },
        });
    }
  }
async loadSvgFromUrl(url: string,iconPackDetail:IconPackDetail) {
 await this.getblobToken();
  this.undoStack=[];
   this.isIcon=true;
    this.iconPackDetail=iconPackDetail;
    const svgImage = url! + (this.blobService.getToken() ?? this.token);

    fetch(svgImage)
      .then(response => {
        if (!response.ok) throw new Error('Failed to fetch SVG');
        return response.text();
      })
      .then(svgContent => {
        // Log raw content
        // ✅ Remove surrounding quotes if present
        svgContent = svgContent.replace(/^["']|["']$/g, '');

        // ✅ Optional: Unescape inner quotes (\" → ")
        svgContent = svgContent.replace(/\\"/g, '"');

        this.fileSelected = true;

        setTimeout(() => {
          this.renderSVGInDiv(svgContent);
          requestAnimationFrame(() => this.extractColorsFromRenderedSVG());
        });
      })
      .catch(error => console.error('Error loading SVG:', error));
}

  reset(): void {
    this.assetsPaginated = null;
    this.assets = [];
    this.total = 0;
    this.page = 1;
    this.itemsPerPage = 100;
  }
  async getPackAssets() {
    // this.assets=[];
    this.loading=true;
    this.isContentPreparing = true;
    this.assetSubscription = await this.packService
      .getPackAssets(
        this.page,
        this.itemsPerPage,
        this.search,
        this.category,
        this.selectedStyle,
        this.content,
        this.selectedAssetCategory,
        this.selectedIconColor,
        this.selectedPreference,
        this.searchLevel
      )
      .subscribe({
        next: (response: PaginatedResult<PackAsset>) => {

          if (response.data) {

            this.assetsPaginated = response;
            if (this.isScrolled) {

              response.data.forEach((newAsset: PackAsset) => {

                const existingCategory = this.assets?.find(
                  (asset) =>
                    asset.category.categoryID === newAsset.category.categoryID
                );
                if (existingCategory) {

                  existingCategory.iconPackDetails.push(
                    ...newAsset.iconPackDetails
                  );
                } else {
                  this.assets.push(newAsset);
                }
              });
            } else {

              this.assets = response.data;
            }
            this.total = response.total!;
            const remaining = this.total - this.page * this.itemsPerPage;
            if (this.isScrolled && remaining >= 10) {

              setTimeout(() => {
                this.loading = false;
                this.isContentPreparing = false;
                this.cdr.detectChanges();
              }, 250);
            } else {

              setTimeout(() => {

                this.loading = false;
                this.isContentPreparing = false;
                this.cdr.detectChanges();
              }, 10);
            }
          }
        },
        error: (err) => {

          this.total = 0;
          setTimeout(() => {
            this.cdr.detectChanges();
            this.loading = false;
            this.isContentPreparing = false;
          }, 10);
          console.error(err);
        },
      });
  }


  onSearch(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;
    this.search = value;
    this.getPackAssets();
  }




  skeletonLoaderItems(size: number): number[] {
    return Array.from({ length: size }, (_, i) => i);
  }

  triggerFileInput(): void {
    this.fileError='';
    this.undoStack=[];
      this.isIcon=false;
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = ''; // Clear the value to allow re-upload of the same file
      this.fileInput.nativeElement.click();
    } else {
      console.error('fileInput is not available');
    }
  }

  onFileChange(event: Event): void {

    const input = event.target as HTMLInputElement;
    if (input?.files && input.files.length > 0) {
      if (input.files[0].type === "image/svg+xml") {  // Corrected comparison
        this.fileSelected = true;
        const file = input.files[0];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const svgContent = e.target.result;
          this.renderSVGInDiv(svgContent);
          requestAnimationFrame(() => this.extractColorsFromRenderedSVG());
        };
        reader.readAsText(file);
      } else {
        this.fileError='Please select a valid SVG file.';
      }
    }
  }

  showTilesOption() {
    this.tilesSelected = true
  }



  renderSVGInDiv(svgContent: string): void {

    const svgContainer: HTMLElement | null = document.getElementById('svgDisplay');

    if (!svgContainer) return;

    svgContainer.innerHTML = ''; // Clear existing content

    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgContent, 'image/svg+xml');

    // Check for parsing errors
    if (svgDoc.querySelector('parsererror')) {
      console.error('Error parsing SVG content.');
      return;
    }

    const svgElement = svgDoc.querySelector('svg');
    if (!svgElement) {
      console.error('No <svg> tag found.');
      return;
    }

    // Clean SVG size
    svgElement.removeAttribute('width');
    svgElement.removeAttribute('height');
    svgElement.style.width = 'auto';
    svgElement.style.height = 'auto';
    svgElement.style.maxWidth = '100%';
    svgElement.style.maxHeight = '100%';
    svgElement.style.display = 'block';

    svgContainer.appendChild(svgElement);

    // Enable clicking on basic shapes
    svgElement.querySelectorAll('path, rect, circle, polygon, text, line, ellipse').forEach((element, index) => {
      element.addEventListener('click', (event) => {
        this.openColorPicker(event as MouseEvent, index); // <- implement this
      });
    });
  }

  openColorPicker(event: MouseEvent, index: number): void {

    const colorInput = document.createElement('input');
    colorInput.type = 'color';

    this.selectedElementIndex = index;

    const target = event.target as HTMLElement;
    const currentColor = this.svgColors[index] || '#000000';
    this.selectedColor = currentColor;

    colorInput.value = this.rgbToHex(currentColor);

    colorInput.style.position = 'fixed';
    colorInput.style.left = `${event.clientX}px`;
    colorInput.style.top = `${event.clientY}px`;
    colorInput.style.width = '30px';
    colorInput.style.height = '30px';
    colorInput.style.border = 'none';
    colorInput.style.cursor = 'pointer';
    colorInput.style.zIndex = '1000';
    colorInput.style.opacity = '0'; // optional if you want it hidden

    document.body.appendChild(colorInput);

    // ✅ Delay click to fix the first-time issue
    setTimeout(() => {
      colorInput.click();
    }, 1000);

    colorInput.addEventListener('input', () => {
      const pickedColor = colorInput.value;
      this.applyColor(pickedColor);
      target.setAttribute('fill', pickedColor);
    });

    colorInput.addEventListener('blur', () => {
      if (document.body.contains(colorInput)) {
        document.body.removeChild(colorInput);
      }
    });
  }


  rgbToHex(rgb: string): string {
    if (rgb.startsWith('#')) return rgb;

    const result = rgb.match(/\d+/g);
    if (!result) return '#000000';

    const r = parseInt(result[0]).toString(16).padStart(2, '0');
    const g = parseInt(result[1]).toString(16).padStart(2, '0');
    const b = parseInt(result[2]).toString(16).padStart(2, '0');

    return `#${r}${g}${b}`;
  }

  applyColorToElement(color: string, index: number): void {
    const svgContainer = document.getElementById('svgDisplay');
    if (!svgContainer) return;

    const svgElements = svgContainer.querySelectorAll('path, rect, circle, polygon, text, line, ellipse');
    const element = svgElements[index];
    if (element) {
      element.setAttribute('fill', color);
      element.setAttribute('stroke', color);
    }
  }

  applyColor(color: string): void {

    if (this.selectedElementIndex !== null) {
      this.saveStateForUndo(); // Add this
      this.svgColors[this.selectedElementIndex] = color;
      this.updateSvgColors(this.selectedElementIndex);
      this.showColorPicker = false;
    }
  }
  saveStateForUndo(): void {
    // this.undoStack=[];
    const svgElement = document.querySelector('#svgDisplay svg');
    if (svgElement) {
      const serializer = new XMLSerializer();
      this.svgString = serializer.serializeToString(svgElement);
      this.undoStack.push(this.svgString);
      this.redoStack = [];
    }
  }

  convertRgbToHex(rgb: string): string {
    const result = rgb.match(/\d+/g);
    if (result === null || result.length < 3) {
      throw new Error('Invalid RGB format');
    }
    const r = parseInt(result[0]);
    const g = parseInt(result[1]);
    const b = parseInt(result[2]);

    if (r < 0 || r > 255 || g < 0 || g > 255 || b < 0 || b > 255) {
      throw new Error('RGB values must be between 0 and 255');
    }
    return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1).padStart(6, '0')}`;
  }

  extractColorsFromRenderedSVG(): void {

    const svgContainer = document.getElementById('svgDisplay');
    if (!svgContainer) return;

    const svgElements = svgContainer.querySelectorAll('path, rect, circle, polygon, text, line, ellipse');
    const colors: string[] = [];
    const uniqueColors: Set<string> = new Set();

    svgElements.forEach(element => {

      let fillColor = element.getAttribute('fill');
      let strokeColor = element.getAttribute('stroke');
      if (fillColor && fillColor.startsWith('rgb')) {
        fillColor = this.convertRgbToHex(fillColor);
      }
      if (strokeColor && strokeColor.startsWith('rgb')) {
        strokeColor = this.convertRgbToHex(strokeColor);
      }
      if (fillColor && fillColor !== 'none') {
        colors.push(fillColor.toLowerCase());
        uniqueColors.add(fillColor.toLowerCase());
      }
      if (strokeColor && strokeColor !== 'none') {
        colors.push(strokeColor.toLowerCase());
        uniqueColors.add(strokeColor.toLowerCase());
      }

      if ((!fillColor || fillColor === 'none') || (!strokeColor || strokeColor === 'none')) {
        const computedStyle = getComputedStyle(element);
        const computedFill = computedStyle.fill;
        const computedStroke = computedStyle.stroke;

        if (computedFill && computedFill !== 'none') {
          const normalizedFill = this.normalizeColor(computedFill);
          colors.push(normalizedFill);
          uniqueColors.add(normalizedFill);
        }
        if (computedStroke && computedStroke !== 'none') {
          const normalizedStroke = this.normalizeColor(computedStroke);
          colors.push(normalizedStroke);
          uniqueColors.add(normalizedStroke);
        }
      }
    });

    this.svgColors = colors;
    this.uniquesvgColors = Array.from(uniqueColors);

    console.table("All Colors", this.svgColors);
    console.table("Unique Colors", this.uniquesvgColors);
  }

  normalizeColor(color: string): string {
    if (color.startsWith('rgb')) {
      return this.convertRgbToHex(color).toLowerCase();
    }
    return color.toLowerCase(); // Hex colors are already normalized
  }

  onColorChange(event: any, index: number) {

    this.svgColors[index] = event.color;
    this.updateSvgColors(index);
  }

  onPalletechanging(colorArray: string[]) {
    this.saveStateForUndo();
    const s = 3
    for (var i = 0; i < this.svgColors.length; i++) {
      if (i < 4) {
        this.svgColors[i] = colorArray[i]
        this.updateSvgColors(i)
      }
      else {
        this.svgColors[i] = colorArray[i - s]
        this.updateSvgColors(i)
      }
    }
  }


  updateSvgColors(index: number): void {

    const svgContainer = document.getElementById('svgDisplay');
    if (!svgContainer) return;

    const svgElements = svgContainer.querySelectorAll('path, rect, circle, polygon, text, line, ellipse');
    const element = svgElements[index];
    if (!element) return;
    const svgElement = element as HTMLElement;
    const fillColor = this.svgColors[index];
    const strokeColor = this.svgColors[index];
    if (fillColor) {
      svgElement.style.setProperty('fill', fillColor, 'important');
    }
    if (strokeColor) {
      svgElement.style.setProperty('stroke', strokeColor, 'important');
    }
  }
onDragOver(event: DragEvent) {
  this.fileError='';
  event.preventDefault(); // Needed to allow dropping
  this.isDragOver = true;
}

onDragLeave(event: DragEvent) {
  this.fileError='';
  event.preventDefault();
  this.isDragOver = false;
}

onDrop(event: DragEvent) {
  this.fileSelected=false;
  event.preventDefault();
  this.isDragOver = false;
  this.isIcon = false;
  if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
    const file = event.dataTransfer.files[0];
    if (file.type === 'image/svg+xml' || file.name.toLowerCase().endsWith('.svg')) {
      // Load new SVG
      this.onFileChange({ target: { files: [file] } } as any);

    } else {
      this.fileError='Please select a valid SVG file.';
    }
  }
}

  downloadSVG(): void {
    const svgContainer = document.getElementById('svgDisplay');
    if (!svgContainer) return;

    const svgContent = svgContainer.innerHTML;
    const svgBlob = new Blob([svgContent], { type: 'image/svg+xml' });
    const svgUrl = URL.createObjectURL(svgBlob);
    const downloadLink = document.createElement('a');
    downloadLink.href = svgUrl;
    downloadLink.download = 'modified.svg';
    downloadLink.click();
    URL.revokeObjectURL(svgUrl);
  }

  sendData(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.height = value + '%'
    this.width = value + '%'
    this.addSVGBackground()
  }

  svgSizes(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.changeSVGsize(value + '%', value + '')
  }

  changeSVGsize(height: string, width: string) {
    const container = document.getElementById("svgDisplay");
    if (container && container instanceof HTMLElement) {
      const svg = container.querySelector('svg');
      if (svg && svg instanceof SVGSVGElement) {
        // Retrieve existing height and width or set defaults if they don't exist
        const currentHeight = svg.getAttribute("height");
        const currentWidth = svg.getAttribute("width");

        const newHeight = height || currentHeight; // Use provided height or fallback
        const newWidth = width || currentWidth;   // Use provided width or fallback

     

        if (newHeight && newWidth) {
          // Set the updated attributes for SVG
          svg.setAttribute("height", newHeight);
          svg.setAttribute("width", newWidth);

          // Ensure background size remains constant
          const background = svg.querySelector('.background') as SVGRectElement | null;
          if (background) {
            const originalHeight = background.getAttribute('height');
            const originalWidth = background.getAttribute('width');

            // Restore the original background size (if it exists)
            if (originalHeight && originalWidth) {
              background.setAttribute('height', originalHeight);
              background.setAttribute('width', originalWidth);
            }
          }
        }
      } else {
        console.error("SVG element not found inside the container.");
      }
    } else {
      console.error("SVG container not found or not an HTMLElement.");
    }
  }

  addSVGBackground() {
    const container = document.getElementById("svgDisplay");

    if (!(container instanceof HTMLElement)) {
      console.error("Container not found or not an HTML element.");
      return;
    }

    const svg = container.querySelector("svg");

    if (!(svg instanceof SVGSVGElement)) {
      console.error("No SVG content found inside the container.");
      return;
    }

    // Remove any existing background shapes
    const backgroundShapes = svg.querySelectorAll(".background");
    backgroundShapes.forEach((shape) => shape.remove());

    // Do not add background if "none"
    if (this.backgroundShape === "none") return;

    const svgWidth =
      svg.viewBox.baseVal?.width || svg.getBoundingClientRect().width || 100;
    const svgHeight =
      svg.viewBox.baseVal?.height || svg.getBoundingClientRect().height || 100;

    const rectWidth = parseFloat(this.width);
    const rectHeight = parseFloat(this.height);
    const x = (svgWidth - rectWidth) / 2;
    const y = (svgHeight - rectHeight) / 2;

    let shape: SVGElement;

    switch (this.backgroundShape) {
      case "squircle":
      case "rounded":
        shape = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        shape.setAttribute("x", x.toString());
        shape.setAttribute("y", y.toString());
        shape.setAttribute("width", this.width);
        shape.setAttribute("height", this.height);
        shape.setAttribute("rx", "12");
        shape.setAttribute("ry", "12");
        break;

      case "circle":
        shape = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        shape.setAttribute("cx", (x + rectWidth / 2).toString());
        shape.setAttribute("cy", (y + rectHeight / 2).toString());
        shape.setAttribute("r", (Math.min(rectWidth, rectHeight) / 2).toString());
        break;

      case "oval":
        shape = document.createElementNS("http://www.w3.org/2000/svg", "ellipse");
        shape.setAttribute("cx", (svgWidth / 2).toString());
        shape.setAttribute("cy", (svgHeight / 2).toString());
        shape.setAttribute("rx", (rectWidth / 2).toString());
        shape.setAttribute("ry", (rectHeight / 2).toString());
        break;

      default:
        shape = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        shape.setAttribute("x", x.toString());
        shape.setAttribute("y", y.toString());
        shape.setAttribute("width", this.width);
        shape.setAttribute("height", this.height);
        break;
    }

    shape.setAttribute("fill", this.backgroundColor);
    shape.setAttribute("class", "background");

    svg.insertBefore(shape, svg.firstChild);
  }

  clear() {
    this.fileError='';
    this.iconPackDetail = null;
    this.fileSelected = false;
    this.tilesSelected=false;
  }
  getCategory(menuName:string):Category | undefined {
    return this.categories.find(category => category.menuName === menuName);
  }
}
